export enum ChargingPlugType {
  rapid = 'rapid',
  standard = 'standard',
}
